
<app-logo-toolbar></app-logo-toolbar>
<app-info-toolbar></app-info-toolbar>

<div class="d-block d-sm-block d-md-none sideContainer shadow mb-1 bg-body rounded">
    <div class="w-25">
        <button mat-icon-button (click)="toogleMenu()">
            <fa-icon [icon]="faBars" class="fa-solid"></fa-icon>
        </button>
    </div>
    <div id="mas_garantia" class="w-75">
        <img>
    </div>
</div>
    <mat-sidenav-container>
        <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
            [(opened)]="openedMenu" fixedTopGap="56">
            <div class="leftMenuContainer">
                <mat-list role="list">
                    <mat-list-item role="listitem" (click)="toogleMenuCenter()"><fa-icon [icon]="faAngleLeft" class="fa-solid"></fa-icon>
                    </mat-list-item>
                    <mat-list-item role="listitem"><a class='text-decoration-none text-muted '
                            href='https://miseguro.liverpool.com.mx/proteccion-integral-familiar'> {{ 'LAYOUT_PAGE.LABEL1' | translate }} </a></mat-list-item>
                    <mat-list-item role="listitem"><a class='text-decoration-none text-muted mt-1'
                            href='https://miseguro.liverpool.com.mx/seguro-de-auto'> {{ 'LAYOUT_PAGE.LABEL2' | translate }} </a></mat-list-item>
                    <mat-list-item role="listitem"><a class='text-decoration-none text-muted mt-1'
                            href='https://miseguro.liverpool.com.mx/proteccion-celular'> {{ 'LAYOUT_PAGE.LABEL3' | translate }} </a>
                    </mat-list-item>
                    <mat-list-item role="listitem"><a class='text-decoration-none text-muted mt-1'
                            href='https://masgarantia.liverpool.com.mx/'> {{ 'LAYOUT_PAGE.LABEL4' | translate }} </a></mat-list-item>

                </mat-list>
            </div>
        </mat-sidenav>

        <mat-sidenav-content>
            <mat-sidenav-container>
                <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'"
                    [fixedInViewport]="mobileQuery.matches" [(opened)]="opened" fixedTopGap="56">
                    <div class="leftMenuContainer">
                        <mat-list role="list">
                            <mat-list-item role="listitem" >{{this.storageService.getData('userName')}}</mat-list-item>
                            <mat-divider></mat-divider>
                            <mat-list-item role="listitem"> {{ 'LAYOUT_PAGE.LABEL5' | translate }} </mat-list-item>
                            <mat-list-item role="listitem" (click)="toogleMenuCenter()">
                                <span style="font-weight: 500;"> {{ 'LAYOUT_PAGE.LABEL6' | translate }} </span> <fa-icon [icon]="faAngleRight"
                                    class="fa-solid" style="margin-left: 10px;"></fa-icon>
                            </mat-list-item>
                            <mat-list-item role="listitem">
                                <a class='text-decoration-none text-reset'
                                    href="https://miseguro.liverpool.com.mx/mis-polizas"> {{ 'LAYOUT_PAGE.LABEL7' | translate }} </a>
                            </mat-list-item>
                            <mat-list-item role="listitem" (click)="logOut()"> {{ 'LAYOUT_PAGE.LABEL8' | translate }} </mat-list-item>

                        </mat-list>
                    </div>
                </mat-sidenav>
                <mat-sidenav-content>
                    <app-home-page></app-home-page>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </mat-sidenav-content>
    </mat-sidenav-container>